import React from 'react';

const AddThis = ({ url }) => {
  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.addthis && url) {
      window.addthis.layers &&
        window.addthis.layers.refresh &&
        window.addthis.layers.refresh();
      window.addthis.update('share', 'url', url);
    }
  }, [url]);

  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src =
      '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-50b3c47c2c439366';

    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  return <div className="addthis_inline_share_toolbox" />;
};

export default AddThis;
